// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compt .search .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
  border: 1px solid var(--app-mid-lighter-2);
  --border-radius: 5px;
  border-radius: 5px;
  padding: 0;
  --box-shadow: none;
}

.sc-body.sc-body--item .scb-car-status, .sc-body.sc-body--item-body .cb-status-circle, .sc-body.sc-body--select .scb-car-status {
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.sc-body.sc-body--item .status-off.scb-car-status, .sc-body.sc-body--item-body .status-off.cb-status-circle, .sc-body.sc-body--select .status-off.scb-car-status {
  background-color: var(--app-danger);
}
.sc-body.sc-body--item .status-on.scb-car-status, .sc-body.sc-body--item-body .status-on.cb-status-circle, .sc-body.sc-body--select .status-on.scb-car-status {
  background-color: var(--app-succ);
}

.sc-body.sc-body--item .sc-body-main .scb-lbl-wrap .scb-lbl, .sc-body.sc-body--item .sc-body-main .scb-id-wrap .scb-id, .sc-body.sc-body--item-body .cb-name, .sc-body.sc-body--item-body .cb-status-lbl, .sc-body.sc-body--select .scb-lbl-wrap .scb-lbl {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.compt {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.compt .search {
  padding: 15px 20px 10px;
}
.compt .search .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
}
.compt .items {
  padding-bottom: 10px;
  flex: 1;
  overflow-y: auto;
}

.compt .search .searchbar {
  /*
  --background	Background of the searchbar
  --cancel-button-color	Color of the searchbar cancel button
  --clear-button-color	Color of the searchbar clear button
  --color	Color of the searchbar text
  --icon-color	Color of the searchbar icon
  --placeholder-color	Color of the searchbar placeholder
  --placeholder-font-style	Font style of the searchbar placeholder
  --placeholder-font-weight	Font weight of the searchbar placeholder
  --placeholder-opacity	Opacity of the searchbar placeholder
  */
  border: 1px solid var(--app-mid-lighter-2);
  --border-radius: 5px;
  border-radius: 5px;
  padding: 0;
  --box-shadow: none;
}

.sc-body.sc-body--select .scb-car-status, .sc-body.sc-body--item-body .cb-status-circle, .sc-body.sc-body--item .scb-car-status {
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.sc-body.sc-body--select .status-off.scb-car-status, .sc-body.sc-body--item-body .status-off.cb-status-circle, .sc-body.sc-body--item .status-off.scb-car-status {
  background-color: var(--app-danger);
}
.sc-body.sc-body--select .status-on.scb-car-status, .sc-body.sc-body--item-body .status-on.cb-status-circle, .sc-body.sc-body--item .status-on.scb-car-status {
  background-color: var(--app-succ);
}

.sc-body.sc-body--select .scb-lbl-wrap .scb-lbl, .sc-body.sc-body--item-body .cb-status-lbl, .sc-body.sc-body--item-body .cb-name, .sc-body.sc-body--item .sc-body-main .scb-id-wrap .scb-id, .sc-body.sc-body--item .sc-body-main .scb-lbl-wrap .scb-lbl {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.ion-activatable {
  position: relative;
}
.ion-activatable.ripple-bounded {
  overflow: hidden;
}
.ion-activatable > ion-ripple-effect.ripple {
  /*&.main-soft {
    color: var(--app-main-soft);
  }*/
}
.ion-activatable > ion-ripple-effect.ripple.contr {
  color: var(--app-contr);
}
.ion-activatable > ion-ripple-effect.ripple.darkest {
  color: var(--app-darkest);
}
.ion-activatable > ion-ripple-effect.ripple.lightest {
  color: var(--app-lightest);
}
.ion-activatable > ion-ripple-effect.ripple.main {
  color: var(--app-main);
}
.ion-activatable > ion-ripple-effect.ripple.main-darker {
  color: var(--app-main-darker);
}
.ion-activatable > ion-ripple-effect.ripple.main-softer {
  color: var(--app-main-softer);
}
.ion-activatable > ion-ripple-effect.ripple.main-strong {
  color: var(--app-main-strong);
}
.ion-activatable > ion-ripple-effect.ripple.mid-light {
  color: var(--app-mid-light);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter {
  color: var(--app-mid-lighter);
}
.ion-activatable > ion-ripple-effect.ripple.mid-lighter-2 {
  color: var(--app-mid-lighter-2);
}

.sc-body.sc-body--item {
  padding: 12px 20px;
  display: flex;
  cursor: pointer;
}
.sc-body.sc-body--item .scb-car-status {
  align-self: center;
  margin-left: 8px;
  margin-right: 10px;
}
.sc-body.sc-body--item .sc-body-main {
  margin-right: -10px;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
}
.sc-body.sc-body--item .sc-body-main .sbm-part {
  margin-right: 10px;
}
.sc-body.sc-body--item .sc-body-main .scb-lbl-wrap {
  display: grid;
}
.sc-body.sc-body--item .sc-body-main .scb-lbl-wrap .scb-lbl.sl-sel-car {
  color: var(--app-mid-dark);
  font-weight: 500;
}
.sc-body.sc-body--item .sc-body-main .scb-id-wrap {
  display: grid;
  grid-auto-flow: column;
  column-gap: 7px;
}
.sc-body.sc-body--item .sc-body-main .scb-id-wrap .scb-id {
  align-self: flex-end;
  color: var(--app-mid);
  font-size: 15px;
}
.sc-body.sc-body--item-body {
  display: grid;
  grid-template-columns: max-content;
  gap: 4px 15px;
}
.sc-body.sc-body--item-body .cb-status-circle {
  align-self: center;
}
.sc-body.sc-body--item-body .cb-name {
  font-size: 17px;
  font-weight: 500;
}
.sc-body.sc-body--item-body .cb-status-lbl {
  grid-column: 2;
  font-size: 14px;
}
.sc-body.sc-body--item-body.texts-dark .cb-name {
  color: var(--app-mid-dark);
}
.sc-body.sc-body--item-body.texts-dark .cb-status-lbl {
  color: var(--app-mid);
}
.sc-body.sc-body--item-body.texts-light .cb-name {
  color: var(--app-base);
}
.sc-body.sc-body--item-body.texts-light .cb-status-lbl {
  color: var(--app-base);
}
.sc-body .checked-item {
  display: flex;
  gap: 5px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
}
.sc-body .pointer {
  cursor: pointer;
}
.sc-body .scroll {
  overflow-y: scroll;
}
.sc-body.sc-body--select {
  flex: 1;
  padding: 10px 15px;
  display: flex;
  align-items: center;
}
.sc-body.sc-body--select .scb-car-status {
  margin-right: 8px;
}
.sc-body.sc-body--select .scb-lbl-wrap {
  display: grid;
}
.sc-body.sc-body--select .scb-lbl-wrap .scb-lbl.sl-sel-car {
  color: var(--app-mid-dark);
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/theme/desktop/desktop.scss","webpack://./src/app/components/desktop/popover-list-participant/popover-list-participant.component.scss"],"names":[],"mappings":"AAqIA;EACE;;;;;;;;;;GAAA;EAYA,0CAhJc;EAkJd,oBAAA;EACA,kBAlJa;EAoJb,UAAA;EAEA,kBAAA;ACxIF;;AD2IA;EACE,kBAAA;EAEA,YAAA;EACA,WAAA;ACzIF;AD2IE;EACE,mCAAA;ACzIJ;AD2IE;EACE,iCAAA;ACzIJ;;ADqOA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;AClOF;;AD4PA;EACE,kBAAA;ACzPF;AD2PE;EACE,gBAAA;ACzPJ;AD6PE;EAwBE;;IAAA;AChRJ;AD0PI;EACE,uBAAA;ACxPN;AD4PI;EACE,yBAAA;AC1PN;AD6PI;EACE,0BAAA;AC3PN;AD+PI;EACE,sBAAA;AC7PN;ADgQI;EACE,6BAAA;AC9PN;ADqQI;EACE,6BAAA;ACnQN;ADsQI;EACE,6BAAA;ACpQN;ADwQI;EACE,2BAAA;ACtQN;ADyQI;EACE,6BAAA;ACvQN;AD0QI;EACE,+BAAA;ACxQN;;AAlEA;EACE,YAAA;EAEA,aAAA;EACA,sBAAA;AAoEF;AAjEE;EACD,uBAAA;AAmED;AAjEC;EAEE;;;;;;;;;;GAAA;AA4EH;AAnDE;EACD,oBAAA;EACA,OAAA;EACA,gBAAA;AAqDD;;AD6BA;EACE;;;;;;;;;;GAAA;EAYA,0CAhJc;EAkJd,oBAAA;EACA,kBAlJa;EAoJb,UAAA;EAEA,kBAAA;AC9BF;;ADiCA;EACE,kBAAA;EAEA,YAAA;EACA,WAAA;AC/BF;ADiCE;EACE,mCAAA;AC/BJ;ADiCE;EACE,iCAAA;AC/BJ;;AD2HA;EACE,mBAAA;EACA,kBAAA;EACA,uBAAA;ACxHF;;ADkJA;EACE,kBAAA;AC/IF;ADiJE;EACE,gBAAA;AC/IJ;ADmJE;EAwBE;;IAAA;ACtKJ;ADgJI;EACE,uBAAA;AC9IN;ADkJI;EACE,yBAAA;AChJN;ADmJI;EACE,0BAAA;ACjJN;ADqJI;EACE,sBAAA;ACnJN;ADsJI;EACE,6BAAA;ACpJN;AD2JI;EACE,6BAAA;ACzJN;AD4JI;EACE,6BAAA;AC1JN;AD8JI;EACE,2BAAA;AC5JN;AD+JI;EACE,6BAAA;AC7JN;ADgKI;EACE,+BAAA;AC9JN;;AAhGE;EACD,kBAAA;EACA,aAAA;EACA,eAAA;AAmGD;AAhGC;EACE,kBAAA;EAEA,gBAAA;EACA,kBAAA;AAiGH;AA5EC;EACE,mBAAA;EACA,OAAA;EAEA,aAAA;EACA,eAAA;AA6EH;AA3EG;EACD,kBAAA;AA6EF;AAzEG;EACD,aAAA;AA2EF;AAlEI;EACD,0BAAA;EACA,gBAAA;AAoEH;AA1DG;EACD,aAAA;EACA,sBAAA;EAEA,eAAA;AA2DF;AAzDE;EACE,oBAAA;EAEA,qBAAA;EACA,eAAA;AA0DJ;AA3CE;EACD,aAAA;EAGA,kCAAA;EAMA,aAAA;AAsCD;AAnCC;EACE,kBAAA;AAqCH;AApBC;EACE,eAAA;EACA,gBAAA;AAsBH;AAbC;EACE,cAAA;EACA,eAAA;AAeH;AATG;EACD,0BAAA;AAWF;AARG;EACD,qBAAA;AAUF;AALG;EACD,sBAAA;AAOF;AAJG;EACD,sBAAA;AAMF;AAAE;EACD,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAED;AACE;EACD,eAAA;AACD;AAEE;EACD,kBAAA;AAAD;AAIE;EACD,OAAA;EACA,kBAAA;EAEA,aAAA;EACA,mBAAA;AAHD;AAKC;EACE,iBAAA;AAHH;AAqBC;EACE,aAAA;AAnBH;AA4BE;EACE,0BAAA;EACA,gBAAA;AA1BJ","sourcesContent":["\n\n$borderDivider: 1px solid var(--app-mid-lighter-2);\n$borderRadius: 5px;\n\n$btnShadow:\n  0 3px 1px -2px rgba(0, 0, 0, 0.2),\n  0 2px 2px 0 rgba(0, 0, 0, 0.14),\n  0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\n$shadow: 0 8px 16px rgba(var(--app-cover-rgb), .15);\n$shadow-sm: 0 4px 8px rgba(var(--app-cover-rgb), .15);\n\n\n// page\n\n$page_minW: 1280px;\n$page_maxW: 1920px;\n\n\n// >media queries\n\n// large screens: 1080p, 2K, 4K\n$pageWild_w: $page_maxW;\n\n\n// >padding\n\n$page_pb50: 50px;\n$page_pb20: 20px;\n\n$page_pt20: 20px;\n$page_pt30: 30px;\n\n$page_px: 20px;\n$page_py20: 20px;\n\n$page_p: $page_pt20 $page_px $page_pb50;\n$page_p-v2: $page_pt30 $page_px $page_pb50;\n\n\n$popover_p: 10px 0;\n\n\n\n\n\n\n\n%btn {\n  margin: 0;\n  font-weight: 600;\n}\n\n%cardHead {\n  border-bottom: $borderDivider;\n  padding: 9px 12px;\n\n  color: var(--app-mid-dark);\n  // font-size: 17px;\n  font-weight: 600;\n\n  display: flex;\n  align-items: center;\n\n\n  /* .card-head-btns {\n    margin-left: auto;\n    padding-left: 20px;\n\n    display: flex;\n    align-items: center;\n  } */\n\n  .card-head-icon {\n    margin-right: 10px;\n    // font-size: 20px;\n    font-size: 18px;\n  }\n\n}\n\n%checkbox {\n  // --border-width: 1px;\n  --border-color: rgba(var(--app-mid-light-rgb), .8);\n  --size: 19px;\n\n  // pointer-events: none;\n}\n\n// aka 'quick actions'\n%mapHudBtns {\n  border-radius: $borderRadius;\n\n  $px: 10px;\n  padding: 7px $px;\n\n  background-color: var(--app-base);\n  display: flex;\n\n  box-shadow: $shadow;\n\n\n  .hqa-btn-wrap {\n\n    .hqa-btn {\n      margin: 0;\n      --border-radius: 50%;\n\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n\n      height: auto;\n\n      font-size: 11px;\n\n      .btn-icon {\n        margin: 8px;\n      }\n    }\n\n\n    &:not(:last-child) {\n      margin-right: $px;\n      border-right: $borderDivider;\n      padding-right: $px;\n    }\n  }\n\n}\n\n%search {\n  /*\n  --background\tBackground of the searchbar\n  --cancel-button-color\tColor of the searchbar cancel button\n  --clear-button-color\tColor of the searchbar clear button\n  --color\tColor of the searchbar text\n  --icon-color\tColor of the searchbar icon\n  --placeholder-color\tColor of the searchbar placeholder\n  --placeholder-font-style\tFont style of the searchbar placeholder\n  --placeholder-font-weight\tFont weight of the searchbar placeholder\n  --placeholder-opacity\tOpacity of the searchbar placeholder\n  */\n\n  border: $borderDivider;\n  // fix: visual glitch\n  --border-radius: #{$borderRadius};\n  border-radius: $borderRadius;\n\n  padding: 0;\n\n  --box-shadow: none;\n}\n\n%statusCircle {\n  border-radius: 50%;\n\n  height: 10px;\n  width: 10px;\n\n  &.status-off {\n    background-color: var(--app-danger);\n  }\n  &.status-on {\n    background-color: var(--app-succ);\n  }\n}\n\n\n// input\n\n%input {\n  // --background\tBackground of the input\n  // --color\tColor of the input text\n  // --padding-bottom\tBottom padding of the input\n  // --padding-end\tRight padding if direction is left-to-right, and left padding if direction is right-to-left of the input\n  // --padding-start\tLeft padding if direction is left-to-right, and right padding if direction is right-to-left of the input\n  // --padding-top\tTop padding of the input\n  // --placeholder-color\tColor of the input placeholder text\n  // --placeholder-font-style\tFont style of the input placeholder text\n  // --placeholder-font-weight\tFont weight of the input placeholder text\n  // --placeholder-opacity\tOpacity of the input placeholder text\n\n  border: $borderDivider;\n  border-radius: 5px;\n\n  // --padding-top: 10px;\n  // --padding-bottom: 10px;\n   --padding-start: 8px;\n  --padding-end: 8px;\n}\n\n%input-lg {\n  @extend %input;\n\n  $p: 12px;\n  --padding-top: #{$p};\n  --padding-bottom: #{$p};\n  --padding-start: #{$p};\n  --padding-end: #{$p};\n}\n\n\n// modal\n\n%modalFooter {\n  border-top: $borderDivider;\n\tpadding: 10px $page_px;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\t.foot-btn {\n\t\tmargin: 0;\n    font-weight: 600;\n\n    // .btn-icon {}\n\n    &.mw-120 {\n      min-width: 120px;\n    }\n\t}\n\n\t&::before {\n\t\tcontent: normal;\n\t}\n}\n\n%modalHeader {\n  padding: 15px $page_px;\n  background-color: var(--app-main-darker);\n\n  .head-elem {\n    &.he-title {\n      margin-bottom: 20px;\n\n      &.mb-0 {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  &.p-20 {\n    padding: $page_py20 $page_px;\n  }\n}\n\n\n// text\n\n%longWord {\n  word-break: break-all;\n  // Edge 79, Firefox 67 - also: deprecated?\n  word-break: break-word;\n}\n\n%oneLiner {\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n}\n\n\n\n\n\n\n\nion-header,\nion-content,\nion-footer {\n  //font-size: 15px;\n\n  // works but must be done on project setup\n  // some elems already in use need white-space: nowrap;\n  // @extend %longWord;\n}\n\n\n\n\n\n\n// effect\n\n.ion-activatable {\n  position: relative;\n\n  &.ripple-bounded {\n    overflow: hidden;\n  }\n\n\n  & > ion-ripple-effect.ripple {\n\n    &.contr {\n      color: var(--app-contr);\n    }\n\n\n    &.darkest {\n      color: var(--app-darkest);\n    }\n\n    &.lightest {\n      color: var(--app-lightest);\n    }\n\n\n    &.main {\n      color: var(--app-main);\n    }\n\n    &.main-darker {\n      color: var(--app-main-darker);\n    }\n\n    /*&.main-soft {\n      color: var(--app-main-soft);\n    }*/\n\n    &.main-softer {\n      color: var(--app-main-softer);\n    }\n\n    &.main-strong {\n      color: var(--app-main-strong);\n    }\n\n\n    &.mid-light {\n      color: var(--app-mid-light);\n    }\n\n    &.mid-lighter {\n      color: var(--app-mid-lighter);\n    }\n\n    &.mid-lighter-2 {\n      color: var(--app-mid-lighter-2);\n    }\n\n  }//& > ion-ripple-effect.ripple\n\n}//.ion-activatable\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n","//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n\n@use \"../../../../theme/desktop/desktop\" as *;\n@forward \"../../../../theme/desktop/desktop\"; // ? needed?\n\n\n\n\n\n// component\n.compt {\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n\n\n  .search {\n\tpadding: 15px $page_px 10px;\n\n\t.searchbar {\n\t  @extend %search;\n\t  /*\n\t  --background\tBackground of the searchbar\n\t  --cancel-button-color\tColor of the searchbar cancel button\n\t  --clear-button-color\tColor of the searchbar clear button\n\t  --color\tColor of the searchbar text\n\t  --icon-color\tColor of the searchbar icon\n\t  --placeholder-color\tColor of the searchbar placeholder\n\t  --placeholder-font-style\tFont style of the searchbar placeholder\n\t  --placeholder-font-weight\tFont weight of the searchbar placeholder\n\t  --placeholder-opacity\tOpacity of the searchbar placeholder\n\t  */\n\n\t  // border: $borderDivider;\n\t  // // fix: visual glitch\n\t  // --border-radius: #{$borderRadius};\n\t  // border-radius: $borderRadius;\n\n\t  // padding: 0;\n\n\t  // --box-shadow: none;\n\t}//.searchbar\n  }//.search\n\n\n  // item list\n  .items {\n\tpadding-bottom: 10px;\n\tflex: 1;\n\toverflow-y: auto;\n\n\t// ! Safari fix\n\t// .items-inner {\n\t//   padding-bottom: 10px;\n\t//   height: 100%;\n\t// }\n  }\n\n\n}//.compt\n\n\n\n//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------\n\n@import \"../../../../theme/desktop/desktop\";\n\n\n.sc-body{\n\n  // %statusCircle {\n  //   border-radius: 50%;\n\n  //   height: 10px;\n  //   width: 10px;\n\n  //   &.status-off {\n  //     background-color: var(--app-danger);\n  //   }\n  //   &.status-on {\n  //     background-color: var(--app-succ);\n  //   }\n  // }\n\n\n  &.sc-body--item{\n\tpadding: 12px $page_px;\n\tdisplay: flex;\n\tcursor: pointer;\n\t// height: 100px; // TEST\n\n\t.scb-car-status{\n\t  align-self: center;\n\n\t  margin-left: 8px;\n\t  margin-right: 10px;\n\n\t  @extend %statusCircle;\n\t  // border-radius: 50%;\n\n\n\t  // height: 10px;\n\t  // width: 10px;\n\n\n\t  // &.status-off {\n\t  //   background-color: var(--app-danger);\n\t  // }\n\t  // &.status-on {\n\t  //   background-color: var(--app-succ);\n\t  // }\n\t}\n\n\t//.scb-car-status\n\n\n\t.sc-body-main{\n\t  margin-right: -10px;\n\t  flex: 1;\n\n\t  display: flex;\n\t  flex-wrap: wrap;\n\n\t  .sbm-part{\n\t\tmargin-right: 10px;\n\t  }\n\n\n\t  .scb-lbl-wrap{\n\t\tdisplay: grid;\n\n\t\t.scb-lbl{\n\t\t  @extend %oneLiner;\n\n\t\t  // &.sl-no-car {\n\t\t  //   padding-top: 1px;\n\t\t  //   color: var(--app-mid-lighter);\n\t\t  // }\n\t\t  &.sl-sel-car{\n\t\t\tcolor: var(--app-mid-dark);\n\t\t\tfont-weight: 500;\n\t\t  }\n\t\t}\n\n\t\t//.scb-lbl\n\t  }\n\n\t  //.scb-lbl-wrap\n\n\n\t  .scb-id-wrap{\n\t\tdisplay: grid;\n\t\tgrid-auto-flow: column;\n\n\t\tcolumn-gap: 7px;\n\n\t\t.scb-id{\n\t\t  align-self: flex-end;\n\n\t\t  color: var(--app-mid);\n\t\t  font-size: 15px;\n\n\t\t  @extend %oneLiner;\n\t\t}\n\t  }\n\n\t  //.scb-id-wrap\n\n\t}\n\n\t//.sc-body-main\n\n  }\n\n\n  &.sc-body--item-body{\n\tdisplay: grid;\n\n\t// cols' width\n\tgrid-template-columns: max-content /*  auto */\n  ;\n\t// grid-auto-columns: max-content;\n\t// rows' height\n\t// grid-auto-rows: auto;\n\n\tgap: 4px 15px;\n\n\n\t.cb-status-circle{\n\t  align-self: center;\n\t  // margin-top: 1px;\n\n\t  @extend %statusCircle;\n\t  // border-radius: 50%;\n\n\t  // height: 10px;\n\t  // width: 10px;\n\n\t  // &.status-off {\n\t  //   background-color: var(--app-danger);\n\t  // }\n\t  // &.status-on {\n\t  //   background-color: var(--app-succ);\n\t  // }\n\t}\n\n\t.cb-name{\n\t  font-size: 17px;\n\t  font-weight: 500;\n\t  @extend %oneLiner;\n\t  // @extend %longWord;\n\n\t  // 2 lines\n\t  // max-height: 38px;\n\t  // overflow-y: hidden;\n\t}\n\n\t.cb-status-lbl{\n\t  grid-column: 2;\n\t  font-size: 14px;\n\t  @extend %oneLiner;\n\t}\n\n\n\t&.texts-dark{\n\t  .cb-name{\n\t\tcolor: var(--app-mid-dark);\n\t  }\n\n\t  .cb-status-lbl{\n\t\tcolor: var(--app-mid);\n\t  }\n\t}\n\n\t&.texts-light{\n\t  .cb-name{\n\t\tcolor: var(--app-base);\n\t  }\n\n\t  .cb-status-lbl{\n\t\tcolor: var(--app-base);\n\t  }\n\t}\n\n  }\n\n  .checked-item{\n\tdisplay: flex;\n\tgap: 5px;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding: 12px 20px;\n  }\n\n  .pointer{\n\tcursor: pointer;\n  }\n\n  .scroll{\n\toverflow-y: scroll;\n  }\n\n\n  &.sc-body--select{\n\tflex: 1;\n\tpadding: 10px 15px;\n\n\tdisplay: flex;\n\talign-items: center;\n\n\t.scb-car-status{\n\t  margin-right: 8px;\n\t  @extend %statusCircle;\n\t  // border-radius: 50%;\n\n\t  // height: 10px;\n\t  // width: 10px;\n\n\t  // &.status-off {\n\t  //   background-color: var(--app-danger);\n\t  // }\n\t  // &.status-on {\n\t  //   background-color: var(--app-succ);\n\t  // }\n\t}\n\n\t//.scb-car-status\n\n\n\t.scb-lbl-wrap{\n\t  display: grid;\n\n\t  .scb-lbl{\n\t\t@extend %oneLiner;\n\n\t\t// &.sl-no-car {\n\t\t//   padding-top: 1px;\n\t\t//   color: var(--app-mid-lighter);\n\t\t// }\n\t\t&.sl-sel-car{\n\t\t  color: var(--app-mid-dark);\n\t\t  font-weight: 500;\n\t\t}\n\t  }\n\n\t  //.scb-lbl\n\t}\n\n\t//.scb-lbl-wrap\n\n  }\n\n\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
